import {
  Row,
  Col,
  Card,
  Tooltip,
  Modal,
  Collapse,
  Typography,
  Form,
  message,
} from "antd";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import styled from "styled-components";
import { Tab, TabItem } from "../../Reusablecomponents/Tab";
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useParams } from "react-router-dom";
import { CALL_API } from "../../Common/api";
import UIModal from "../../Reusablecomponents/UIModal";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import { ReactComponent as BlueLoc } from "../../assets/images/BLUELOC.svg";
import { ReactComponent as Add } from "../../assets/images/Buttons (1).svg";
import { ReactComponent as Alert1 } from "../../assets/images/alert1.svg";
import { ReactComponent as Alert2 } from "../../assets/images/alert2.svg";
import { ReactComponent as Alert3 } from "../../assets/images/alert3.svg";
import { ReactComponent as Alert4 } from "../../assets/images/alert4.svg";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import {
  ShipmentType,
  DispatchType,
  CargoFinishType as FinishType,
  TripTypeEnum,
  priorityType,
  LockStatus,
  TripStatus,
} from "../../Common/constant";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MapComponent from "../../Reusablecomponents/MapComponent";
import { ReactComponent as Speed } from "../../assets/images/speed (2).svg";
import { ReactComponent as Weak } from "../../assets/images/signal-weak.svg";
import { ReactComponent as Strong } from "../../assets/images/signal-strong.svg";
import { ReactComponent as RedDelete } from "../../assets/images/red-delete.svg";
import { ReactComponent as GreenBattery } from "../../assets/images/gg_battery.svg";
import { ReactComponent as Edit } from "../../assets/images/black-edit.svg";
import { ReactComponent as Lock } from "../../assets/images/Lock.svg";
import { ReactComponent as BlackLock } from "../../assets/images/black-lock.svg";
import { ReactComponent as RedUnlock } from "../../assets/images/red-unlock.svg";
const { Panel } = Collapse;
const { Text } = Typography;
export const TitleStyle = styled.div`
  @media (max-width: 768px) {
    .mapboxgl-map {
      width: 40%;
      border-radius: 12px;
    }
  }

  @media (max-width: 1024px) {
    .mapboxgl-map {
      width: 40%;
    }
    .container_map_component {
      background-color:;
      flex-direction: column !important;
    }
    .container_map_subcomponent {
      max-width: 100% !important ;
      flex: 100% !important;
      margin: 9px 0px 9px 0px;
    }
    .mapcomponent_subcontainer {
    }
  }

  @media (min-width: 1026px) and (max-width: 1440px) {
    .mapboxgl-map {
      width: 30%;
    }
    .container_map_component {
      background-color:;
      flex-direction: column !important;
    }
    .container_map_subcomponent {
      max-width: 100% !important ;
      flex: 100% !important;
      margin: 9px 0px 9px 0px;
    }
    .map_container_three {
      width: 100% !important ;
    }
  }

  /*  
  @media (min-width: 1441px) and (max-width: 2560px) {
    .mapboxgl-map {
      width: 30%;
    }
    .container_map_component {
      background-color: ;
      flex-direction: column !important;
    }
    .container_map_subcomponent {
      max-width: 100% !important ;
      flex: 100% !important;
      margin: 9px 0px 9px 0px;
    }
    .map_container_three {
      width: 100% !important ;
    }
  } */

  .title {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-lockspacing: 0%;
    width: 205;
    height: 17;
    color: #363636;
  }
  .asset-info {
    font-weight: 500;
    font-size: 14px;
  }
  .asset-content {
    font-weight: 400;
    font-size: 14px;
  }
  .asset-value {
    color: #979797;
    word-break: break-word;
    white-space: normal;
  }
`;
//actual column
const consignColumns1 = [
  {
    title: "Device Name",
    dataIndex: "FAssetID",
    key: "FAssetID",
  },
  {
    title: "Status",
    dataIndex: "FType",
    key: "FType",
    render: (text) => {
      const isUnlocked = text === 1; // FType = 1 means Unlocked
      const label = isUnlocked ? "Unlocked" : "Locked";
      const Icon = isUnlocked ? RedUnlock : Lock;

      return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Icon style={{ width: "16px", height: "16px" }} />
          <span>{label}</span>
        </div>
      );
    },
  },
  {
    title: "Date",
    dataIndex: "FCreateTime",
    key: "Date",
    render: (text) => {
      const date = new Date(text);
      return date.toLocaleDateString("en-GB", {
        timeZone: "Africa/Nairobi",
      }); // "24/06/2025" in EAT
    },
  },
  {
    title: "Time",
    dataIndex: "FCreateTime",
    key: "Time",
    render: (text) => {
      if (!text) return "-";
      const date = new Date(text);
      date.setHours(date.getHours() + 3);
      return date.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    },
  },
  {
    title: "Location",
    dataIndex: "locationName",
    key: "locationName",
    render: (text) => <span>{text || "-"}</span>,
  },
  {
    title: "User",
    dataIndex: "FUserName",
    key: "FUserName",
  },
];

// const alertData = [
//   {
//     icon: <Alert1 style={{ color: "red", fontSize: 18 }} />,
//     title: "Route Deviation Alarm",
//   },
//   {
//     icon: <Alert2 style={{ color: "red", fontSize: 18 }} />,
//     title: "Unlocked Container Exit Alarm",
//   },
//   {
//     icon: <Alert3 style={{ color: "red", fontSize: 18 }} />,
//     title: "Rope Cut Alarm",
//   },
//   {
//     icon: <Alert4 style={{ color: "red", fontSize: 18 }} />,
//     title: "Tamper Alert",
//   },
//   {
//     icon: <Alert2 style={{ color: "red", fontSize: 18 }} />,
//     title: "Restricted Area Unlock Attempt",
//   },
// ];

const TripDetails = () => {
  const location = useLocation();
  const [consign, setConsign] = useState(location.state || {});
  const { tripId } = useParams();
  const [form] = Form.useForm();
  const [companyList, setCompanyList] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [routeList, setRouteList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [consignee, setConsignee] = useState([]);
  const [tripStatus, setTripStatus] = useState("");
  const [tripDetails, setTripDetails] = useState([]);
  const [activeTab, setActiveTab] = useState("lock-status-history");
  const [open, setOpen] = useState(false);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const [CsvLockData, setCsvLockData] = useState([]);
  const csvLinkEl = useRef(null);
  // const [permissions, setPermissions] = useState([]);
  // const [selectedSections, setSelectedSections] = useState([]);
  const navigate = useNavigate();
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const createAllowed = useMemo(
    () => hasPermission("TRPMONITOR", "CT"),
    [reduxPermissions],
  );
  const updateAllowed = useMemo(
    () => hasPermission("TRPMONITOR", "UT"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("TRPMONITOR", "DT"),
    [reduxPermissions],
  );
  const unlockAllowed = useMemo(
    () => hasPermission("TRPMONITOR", "LU"),
    [reduxPermissions],
  );
  const [formData, setFormData] = useState({
    company: consign?.ConsignorName,
    consignor: consign?.CustId,
    transporter: consign?.Transporter,
    priority: consign?.PRIORITY,
    dispatchtype: consign?.DispatchTypeName,
    shipmenttype: consign?.ShipmentTypeId,
    pickup: consign?.PICKUPDATETIME ? dayjs(consign.PICKUPDATETIME) : null,
    dropoff: consign?.DROPOFFDATETIME ? dayjs(consign.DROPOFFDATETIME) : null,
    vehicle: consign?.VEHREGNO?.[0],
    triptype: consign?.TRIPTYPE,
    finishtype: consign?.FinishType,
    consignee: consign?.ConsigneeID,
    device: consign?.DeviceName,
    container: consign?.ContainerNo?.[0],
    delivery: consign?.FWayBill,
    route: consign?.RouteName,
    reason: consign?.ReasonToChange || "",
    freedays: consign?.FreeDays ? dayjs(consign.FreeDays) : null,
    driver: consign?.DriverName || "",
    phone: consign?.DriverPhone || ""
  });

  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  const permissions = [
    {
      Group: "Position Slip",
      Sections: [
        { secCode: "SEC001", section: "Position_Slip_001" },
        { secCode: "SEC002", section: "Position_Slip_002" },
      ],
    },
    {
      Group: "Interchange",
      Sections: [
        { secCode: "SEC003", section: "Interchange_001" },
        { secCode: "SEC004", section: "Interchange_002" },
      ],
    },
    {
      Group: "Group 3",
      Sections: [
        { secCode: "SEC005", section: "Section 3.1" },
        { secCode: "SEC006", section: "Section 3.2" },
      ],
    },
  ];

  const selectedSections = [
    { SECCODE: "SEC001" },
    { SECCODE: "SEC003" },
    { SECCODE: "SEC005" },
  ];

  const [companyName, setCompanyName] = useState([]);
  const [lockHistoryData, setLockHistoryData] = useState([]);
  const [assetInfoStatus, setAssetInfoStatus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [locationData, setLocationData] = useState([]);
  const [mapData, setMapData] = useState(null); // stores FObject[0]
  const [selectedRecord, setSelectedRecord] = useState(null);

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };
  const handleClose = () => {
    setOpen(false);
    setFormData({
      company: userInfo?.MCID === 59 ? "" : userInfo?.COMPNAME || "",
      consignor: "",
      transporter: "",
      priority: "",
      dispatchtype: "",
      shipmenttype: "",
      pickup: "",
      dropoff: "",
      vehicle: "",
      triptype: "",
      finishtype: "",
      consignee: "",
      device: "",
      container: "",
      delivery: "",
      route: "",
      reason: "",
      freedays: "",
      driver: "",
      phone: ""
    });
    form.resetFields();
  };

  const [isUnlockModalVisible, setIsUnlockModalVisible] = useState(false);

  const handleUnlock = async () => {
    try {
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `container/deviceUnlock`,
        {
          FAssetGUID: assetInfoStatus?.FObject[0]?.FAssetGUID, // Replace with dynamic value if needed
        },
      );
      if (data?.Result != 200) {
        message.error(data?.Message);
      } else {
        message.success("Device Unlocked Successfully!");
      }
    } catch (error) {
      console.error("Error unlocking device:", error);
      message.error("An error occurred while unlocking the device.");
    } finally {
      setIsUnlockModalVisible(false); // Close the modal
    }
  };

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  const handleDelete = async () => {
    try {
      setLoading(true);
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `container/deviceDelete`,
        {
          RouteDepartureGUID: consign?.FWayBillGUID, //FWayBillGUID
          TripId: tripId,
          VehicleName: consign?.VEHREGNO?.[0],
        },
      );
      if (ResponseCode === 200) {
        setLoading(false);
        message.success("Trip deleted successfully!");
        navigate("/tripMonitoring");
      } else {
        setLoading(false);
        console.warn("Delete failed", data);
        message.error("Failed to delete Trip.");
      }
    } catch (error) {
      console.error("Error deleting Trip:", error);
      message.error("An error occurred while Trip the device.");
    } finally {
      setIsDeleteModalVisible(false); // Close the modal
    }
  };

  const getSingleTripDetails = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `container/getSingleTripDetails?tripId=${tripId}`,
      );
      setTripDetails(data);
    } catch (error) {
      console.error("[getSingleTripDetails] error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitForm = async (values) => {
    setLoading(true);
    try {
      const payload = {
        VehId: consign?.VEHID,
        VehRegNo: consign?.VEHREGNO?.[0],
        TripType: consign.TRIPTYPE,
        FCompGUID: consign?.ConsignorID,
        FinishType: consign?.FinishType,
        ShipmentTypeId: consign?.ShipmentTypeId,
        MCID: userInfo?.MCID,
        CRBY: userInfo?.UID,
        FreeDays: consign?.FreeDays
          ? dayjs(consign.FreeDays).format("YYYY-MM-DD")
          : formData.freedays
            ? dayjs(formData.freedays).format("YYYY-MM-DD")
            : null,
        DriverName: formData.driver || "",
        DriverPhone: formData.phone || null,
        temporaryContainerConsignmentList: [
          {
            CONSIGNID: consign?.CONSIGNID,
            DeviceName: consign?.DeviceName,
            RouteName: consign?.RouteName,
            ContainerNo: consign?.ContainerNo?.[0],
            CustId: consign?.CustId,
            ConsignorID: consign?.ConsignorID,
            ConsignorName: consign?.ConsignorName,
            TransporterId: consign?.TransporterId,
            ConsigneeID: consign?.ConsigneeID,
            DispatchTypeID: consign?.DispatchTypeID,
            Priority: consign?.PRIORITY,
            DispatchTypeName: consign?.DispatchTypeName,
            PickUpDateTime: consign?.PICKUPDATETIME
              ? dayjs(consign.PICKUPDATETIME)
              : null,
            DropOffDateTime: consign?.DROPOFFDATETIME
              ? dayjs(consign.DROPOFFDATETIME)
              : null,
            DeviceID: consign?.DeviceID,
            RouteID: consign?.RouteID,
            FWayBillGUID: consign?.FWayBillGUID,
            FWayBill: consign.FWayBill,
            TripType: consign?.TRIPTYPE,
            ShipmentTypeId: consign?.ShipmentTypeId,
            MCID: userInfo?.MCID,
            CRBY: userInfo?.UID,
            FCompGUID: consign?.ConsignorID,
            TripId: consign?.TRIPID,
            ReasonToChange: consign?.ReasonToChange ?? formData?.reason,
          },
        ],
      };
      const { data } = await CALL_API("POST", "container/bulkPost", payload);
      message.success("Data Updated Successfully");
      // fetchTrips();
      // fetchTransportationReport();
      setOpen(false);
      setLoading(false);
    } catch (error) {
      console.error("Submit Error:", error);
      message.error("Failed to update data. Please try again.");
    }
  };

  useEffect(() => {
    if (location.state) {
      setConsign(location.state);
    }
  }, [location.state]);

  // Lock status History for single Trip

  const fetchLockStatusHistroy = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `container/lockStatusHistory?aTripId=${tripId}`,
      );

      const enrichedData = await Promise.all(
        (data || []).map(async (record) => {
          if (record.FLatitude && record.FLongitude) {
            const locationName = await fetchLocation(
              record.FLatitude,
              record.FLongitude,
            );
            return { ...record, locationName };
          }
          return { ...record, locationName: "-" };
        }),
      );

      setLockHistoryData(enrichedData);
    } catch (error) {
      console.error("[fetchLockStatusHistory] error:", error);
      message.error("Error fetching lock status history");
    } finally {
      setLoading(false);
    }
  }, [tripId]);

  //Get Company Name
  const fetchTransportationReport = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `container/getTransportationReport?aTripId=${tripId}`,
      );
      setCompanyName(data);
    } catch (error) {
      console.error("[fetchTransportationReport] error:", error);
      message.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  }, []);

  //Asset Info and Status for single Trip
  const queryVehicleByTripId = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `container/queryVehicleByTripId?tripId=${tripId}`,
      );
      const record = data?.FObject?.[0];
      if (record?.FLatitude && record?.FLongitude) {
        const locationName = await fetchLocation(
          record.FLatitude,
          record.FLongitude,
        );
        setMapData({
          ...record,
          locationName,
        });
      }
      setAssetInfoStatus(data);
    } catch (error) {
      console.error("[queryVehicleByTripId] error:", error);
      message.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    queryVehicleByTripId();
    fetchTransportationReport();
  }, []);

  useEffect(() => {
    fetchLockStatusHistroy();
  }, [fetchLockStatusHistroy]);

  //http://127.0.0.1:3000/container/getConsignee?tripId=24

  const getConsignee = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `container/getConsignee?tripId=${tripId}`,
      );
      const consignee = data?.entities?.[0]?.recname;
      setConsignee(consignee);
      setTripStatus(data?.entities?.[0]?.tripstatus);
    } catch (error) {
      console.error("[getConsignee] error:", error);
      message.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getConsignee();
    getSingleTripDetails();
  }, []);
  useEffect(() => {
    fetchAllCompany();
    fetchAllVehicle();
    fetchAllRoute();
    fetchAllDevice();
  }, []);

  const fetchAllCompany = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllCompany");
      setCompanyList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllVehicle = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllVehicle");
      setVehicleList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllRoute = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllRoute");
      setRouteList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllDevice = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllDevice");
      const devices = data?.companies || [];
      setDeviceList(devices);
    } catch (error) {
      console.error("[fetchAllDevice] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  const [filteredVehicleList, setFilteredVehicleList] = useState([]);
  const [filteredDeviceList, setFilteredDeviceList] = useState([]);
  const [filteredRouteList, setFilteredRouteList] = useState([]);
  const handleCompanyChange = (companyId) => {
    try {
      if (!companyId) {
        setFilteredVehicleList([]);
        setFilteredDeviceList([]);
        setFilteredRouteList([]);
        return;
      }

      const filteredVehicles = vehicleList.filter(
        (v) => v.FAgentGUID === companyId,
      );
      const filteredDevices = deviceList.filter(
        (d) => d.FAgentGUID === companyId,
      );
      const filteredRoutes = routeList.filter(
        (r) => r.FAgentGUID === companyId,
      );
      setFilteredVehicleList(filteredVehicles);
      setFilteredDeviceList(filteredDevices);
      setFilteredRouteList(filteredRoutes);
    } catch (error) {
      console.error("[handleCompanyChange] error:", error);
    }
  };
  useEffect(() => {
    handleCompanyChange(consign?.ConsignorID);
  }, [formData.company, vehicleList, deviceList, routeList]);
  const companyOptions = companyList.map((item) => ({
    value: item.FAgentGUID,
    label: item.FName,
  }));
  const vehicleOptions = filteredVehicleList.map((item) => ({
    value: item.FGUID,
    label: item.FVehicleName,
  }));
  const routeOptions = filteredRouteList.map((item) => ({
    value: item.FRouteGUID,
    label: item.FRouteName,
  }));
  const deviceOptions = filteredDeviceList.map((item) => ({
    value: item.FGUID,
    label: item.FAssetID,
  }));
  const fetchLocation = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json?access_token=pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow`,
      );
      const data = await response.json();
      return data?.features?.[0]?.place_name || "Unknown Location";
    } catch (error) {
      console.error("Error fetching location:", error);
      return "Unknown Location";
    }
  };

  const exportLockCSV = async () => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API(
        "GET",
        `container/lockStatusHistory?aTripId=${tripId}`,
      );

      const formatted = data.map((item) => {
        const isUnlocked = item.FType === 1;
        const status = isUnlocked ? "Unlocked" : "Locked";
        const date = new Date(item.FCreateTime);
        const dateStr = date.toLocaleDateString("en-GB"); // "dd/mm/yyyy"
        const timeStr = date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });

        return {
          "Device Name": item.FAssetID || "-",
          Status: status,
          Date: dateStr,
          Time: timeStr,
          Location: item.loc || "-",
          Coordinates:
            item.FLatitude && item.FLongitude
              ? `(${item.FLatitude}, ${item.FLongitude})`
              : "-",
          User: item.FUserName || "-",
        };
      });

      setCsvLockData(formatted);

      // Trigger CSV download after setting data
      setTimeout(() => {
        if (csvLinkEl.current) {
          csvLinkEl.current.link.click();
        }
      }, 100);
    } catch (error) {
      console.error("[exportLockCSV] error:", error);
      message.error("Failed to export lock status data.");
    } finally {
      setCSVLoader(false);
    }
  };

  //FILES TAB COMMENTED

  // const tabItems = [
  // TabItem({
  //   label: "Files",
  //   content: (
  //     <div className="mt-0 pt-0">
  //       {/* Heading */}
  //       <h5
  //         style={{
  //           fontWeight: 500,
  //           fontSize: "14px",
  //           marginLeft: "10px",
  //           color: "#363636",
  //         }}
  //       >
  //         Documents
  //       </h5>
  //       <Card style={{ backgroundColor: "transparent", border: "none" }}>
  //         <Collapse defaultActiveKey={["0"]} bordered={false}>
  //           {permissions.map((group, groupIndex) => {
  //             const filteredSections = group.Sections.filter((item) =>
  //               selectedSections?.some((val) => val?.SECCODE === item.secCode)
  //             );

  //             if (filteredSections.length === 0) return null;

  //             return (
  //               <Panel
  //                 key={groupIndex}
  //                 header={
  //                   <div className="d-flex justify-content-between align-items-center">
  //                     <div className="d-flex align-items-center">
  //                       <div
  //                         style={{
  //                           width: "6px",
  //                           height: "30px",
  //                           borderRadius: "4px",
  //                           marginRight: "10px",
  //                           backgroundColor:
  //                             group.Group === "Position Slip"
  //                               ? "#81E4E8"
  //                               : group.Group === "Interchange"
  //                               ? "#818FE8"
  //                               : "#999", // fallback color
  //                         }}
  //                       />
  //                       <span style={{ fontWeight: 500 }}>{group.Group}</span>
  //                     </div>
  //                     <span style={{ fontWeight: 500 }}>
  //                       {filteredSections.length}{" "}
  //                       {filteredSections.length === 1 ? "File" : "Files"}
  //                     </span>
  //                   </div>
  //                 }
  //               >
  //                 {filteredSections.map((section, sectionIndex) => (
  //                   <div
  //                     key={sectionIndex}
  //                     className="d-flex justify-content-between align-items-center px-3 py-2"
  //                     style={{
  //                       background: "#f9f9f9",
  //                       borderRadius: "8px",
  //                       borderTop: "1px solid #eee",
  //                     }}
  //                   >
  //                     <span
  //                       style={{
  //                         color: "#5F6D8C",
  //                         fontWeight: 400,
  //                         fontSize: "15px",
  //                       }}
  //                     >
  //                       {section.section}
  //                     </span>
  //                     <span
  //                       style={{
  //                         fontSize: "15px",
  //                         fontWeight: 400,
  //                         color: "#5F6D8C",
  //                       }}
  //                     >
  //                       Uploaded By: John Doe
  //                     </span>
  //                   </div>
  //                 ))}
  //               </Panel>
  //             );
  //           })}
  //         </Collapse>
  //       </Card>
  //     </div>
  //   ),
  // }),
  // ];

  const tabItems = [
    TabItem({
      label: "Lock Status History",
      content: (
        <StyledTable
          columns={consignColumns1}
          dataSource={lockHistoryData}
          pagination={false}
        />
      ),
    }),
    TabItem({
      label: "Alerts",
      // content: (
      //   <div>
      //     {alertData.map((alert, index) => (
      //       <div
      //         key={index}
      //         style={{
      //           display: "flex",
      //           alignItems: "flex-start",
      //           borderBottom: "1px solid #f0f0f0",
      //           paddingBottom: 12,
      //           marginBottom: 12,
      //         }}
      //       >
      //         {/* Alert Icon + Title and Location */}
      //         <div
      //           style={{
      //             width: 220,
      //             display: "flex",
      //             flexDirection: "column",
      //             gap: 8,
      //           }}
      //         >
      //           {/* Alert Icon + Title */}
      //           <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      //             {alert.icon}
      //             <Text
      //               style={{
      //                 color: "#F0181C",
      //                 fontSize: 14,
      //                 fontWeight: 500,
      //               }}
      //             >
      //               {alert.title}
      //             </Text>
      //           </div>

      //           {/* Location */}
      //           <div>
      //             <Text type="secondary" style={{ fontSize: 14 }}>
      //               Location
      //             </Text>
      //             <br />
      //             <BlueLoc style={{ color: "#1890ff" }} />{" "}
      //             <Text style={{ color: "#1890ff" }}>
      //               {"Westlands Woods" || "Unknown"}
      //             </Text>
      //           </div>
      //         </div>

      //         {/* Date */}
      //         <div style={{ width: 100 }}>
      //           <Text type="secondary" style={{ fontSize: 14 }}>
      //             Date
      //           </Text>
      //           <br />
      //           <Text>{"26-02-2025" || "-"}</Text>
      //         </div>

      //         {/* Time */}
      //         <div style={{ width: 100 }}>
      //           <Text type="secondary" style={{ fontSize: 14 }}>
      //             Time
      //           </Text>
      //           <br />
      //           <Text>{"17:08:32" || "-"}</Text>
      //         </div>
      //       </div>
      //     ))}
      //   </div>
      // ),
    }),
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSelectChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };
  const reftab = formData ? "Tripmonitoringcreate" : null;
  const [customFields, setCustomFields] = useState([]);

  const loadCustomFields = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: reftab,
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCustomFields();
  }, [reftab]);

  const customFieldOptions = Array.isArray(customFields)
    ? customFields.map((field) => ({
      label: field.FIELDNAME,
      value: field.CFID,
      disabled: false,
    }))
    : [];

  const customfielvalues = Array.isArray(customFields)
    ? customFields.map((item, index) => {
      const isdropdown = item?.FIELDTYPE === 1;
      const DATASOURCE =
        isdropdown && item?.DATASOURCE
          ? item?.DATASOURCE?.split(",").map((item, index) => {
            return { label: item.trim(), value: item.trim() };
          })
          : [];
      return {
        id: 18 + index,
        label: item.FIELDNAME.replace(/_/g, " ").replace(/\b\w/g, (l) =>
          l.toUpperCase(),
        ),
        type: isdropdown ? "selectwithvalue" : "text" || "checkbox",
        name: item.FIELDNAME,
        options: DATASOURCE,
        maxLength: item.MAXLEN || 50,
        validationRules: item.REQUIRED
          ? [{ required: true, message: `${item.FIELDNAME} is required` }]
          : [],
      };
    })
    : [];

  const AddEditForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [6],
        fields: [
          [
            {
              id: 0,
              label: (
                <b
                  style={{ color: "black", fontWeight: 500, fontSize: "16px" }}
                >
                  Trip Configuration
                </b>
              ),
              type: "phone",
            },
            {},
            {},
            {},
          ],
          [
            {
              id: 1,
              label: "Company",
              type: "selectwithvalue",
              name: "company",
              disabled: userInfo?.MCID !== 59,
              options: companyOptions,
              maxLength: 50,
              style: { width: "259px", height: "36px", gap: "10px" },
              validationRules: [
                { required: true, message: "Company is required" },
              ],
            },
            {
              id: 2,
              label: "Consignor",
              type: "selectwithvalue",
              name: "consignor",
              placeholder: "Enter First Name",
              options: consignerList?.map((item) => ({
                label: item.Name,
                value: item.ID,
              })),
              maxLength: 50,
              validationRules: [
                { required: true, message: "Consignor is required" },
              ],
            },
            {
              id: 3,
              label: "Consignee",
              type: "selectwithvalue",
              name: "consignee",
              options: consigneeList?.map((item) => ({
                label: item.Name,
                value: item.ID,
              })),
              validationRules: [
                { required: true, message: "Consignee is required" },
              ],
            },
            {
              id: 4,
              label: "Transporter",
              type: "selectwithvalue",
              name: "transporter",
              placeholder: "Enter Last Name",
              maxLength: 50,
              options: transporterList?.map((item) => ({
                label: item.Name,
                value: item.ID,
              })),
              style: { width: "259px", height: "36px", gap: "10px" },
              validationRules: [
                { required: true, message: "Transporter is required" },
              ],
            },
          ],
          [
            {
              id: 5,
              label: "Dispatch Type",
              type: "selectwithvalue",
              name: "dispatchtype",
              options: DispatchType?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
              validationRules: [
                { required: true, message: "Dispatch Type is required" },
              ],
            },
            {
              id: 6,
              label: "Shipment Type",
              type: "selectwithvalue",
              name: "shipmenttype",
              options: ShipmentType?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
              placeholder: "Enter Phone Number",
              style: { width: "259px", height: "36px", gap: "10px" },
              validationRules: [
                { required: true, message: "Shipment Type is required" },
              ],
            },
            {
              id: 10,
              label: "Trip Type",
              type: "selectwithvalue",
              name: "triptype",
              options: TripTypeEnum?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
              validationRules: [
                { required: true, message: "Trip Type is required" },
              ],
            },
            {
              id: 11,
              label: "Finish Type",
              type: "selectwithvalue",
              name: "finishtype",
              options: FinishType?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
              validationRules: [
                { required: true, message: "Finish Type is required" },
              ],
            },
          ],
          [
            {
              id: 7,
              label: "Pickup Date Time",
              type: "date",
              name: "pickup",
              showtime: true,
              format: "YYYY-MM-DD HH:mm:ss",
              validationRules: [
                { required: true, message: "Pickup Date Time is required" },
              ],
            },
            {
              id: 8,
              label: "Dropoff Date Time",
              type: "date",
              name: "dropoff",
              showtime: true,
              format: "YYYY-MM-DD HH:mm:ss",
              validationRules: [
                { required: true, message: "Dropoff Date Time is required" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const pickup = getFieldValue("pickup");
                    if (!value || !pickup) return Promise.resolve();

                    if (dayjs(value).isAfter(dayjs(pickup))) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "Drop-off Date & Time must be later than Pick-up Date & Time.",
                      ),
                    );
                  },
                }),
              ],
            },
            {
              id: 17,
              label: "Free Days",
              type: "date",
              name: "freedays",
              showtime: false,
              placeholder: "Select Date",
              format: "YYYY-MM-DD",
              validationRules: [
                { required: false, message: "Free Days is required" },
              ],
            },
            {
              id: 16,
              label: "Route",
              type: "selectwithvalue",
              name: "route",
              options: routeOptions,
              validationRules: [
                { required: true, message: "Route is required" },
              ],
            },
          ],
          [
            {
              id: 0,
              label: (
                <b
                  style={{ color: "black", fontWeight: 500, fontSize: "16px" }}
                >
                  Vehicle & Container Assignment
                </b>
              ),
              type: "phone",
            },
            {},
            {},
            {},
          ],
          [
            {
              id: 9,
              label: "Vehicle",
              type: "selectwithvalue",
              name: "vehicle",
              options: vehicleOptions,
              validationRules: [
                { required: true, message: "Vehicle is required" },
              ],
            },
            {
              id: 13,
              label: "Device",
              type: "selectwithvalue",
              name: "device",
              options: deviceOptions,
              validationRules: [
                { required: true, message: "Device is required" },
              ],
            },
            {
              id: 9,
              label: "Driver Name",
              type: "text",
              name: "driver",
              options: vehicleOptions,
              validationRules: [
                { required: true, message: "Driver Name is required" },
              ],
            },
            {
              id: 9,
              label: "Phone",
              type: "text",
              name: "phone",
              validationRules: [
                { required: true, message: "Phone is required" },
              ],
            },
          ],
          [
            {
              id: 14,
              label: "Container No.",
              type: "text",
              name: "container",
              validationRules: [
                { required: true, message: "Container No. is required" },
              ],
            },
            {
              id: 15,
              label: "Delivery No.",
              type: "text",
              name: "delivery",
              validationRules: [
                { required: true, message: "Deliver No. is required" },
              ],
            },

            {
              id: 15,
              label: "Reason To Change",
              type: "text",
              name: "reason",
              validationRules: [
                { required: true, message: "Reason To Change is required" },
              ],
            },
            {},
          ],
        ],
      },
    ],
  };
  const customFieldsWithColSpan = customfielvalues.map((field) => ({
    ...field,
    colSpan: 6,
  }));

  const groupedCustomFields = [];
  for (let i = 0; i < customFieldsWithColSpan.length; i += 4) {
    groupedCustomFields.push(customFieldsWithColSpan.slice(i, i + 4));
  }
  // Step 3: Merge with AddEditForm
  const combinedForm = {
    ...AddEditForm,
    pages: AddEditForm.pages.map((page) => ({
      ...page,
      fields: [...page.fields, ...groupedCustomFields],
    })),
  };
  const formatDateTimeEAT = (isoString) => {
    if (!isoString) return "-";
    const date = new Date(isoString);

    // Format as "HH:mm, dd/MM/yyyy" in EAT
    const time = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    const day = date.toLocaleDateString("en-GB");

    return `${time}, ${day}`;
  };
  const vehicleReg = Array.isArray(consign.VEHREGNO)
    ? consign.VEHREGNO[0]
    : consign.VEHREGNO;

  const vehicleData = vehicleList.find((v) => v.FVehicleName === vehicleReg);

  return (
    <>
      <TitleStyle>
        <Row gutter={16} className="container_map_component">
          {/* Left Column */}
          <Col
            xs={8}
            sm={8}
            md={16}
            lg={16}
            xl={16}
            className="container_map_subcomponent"
          >
            <div>
              {/* <MapComponent 
              routePoints={startEndLoc}
              locationsTL={locationData} /> */}
              {/* Map Placeholder */}
              <div
                style={{
                  height: "100%",
                  minHeight: 300,
                  width: "100%",
                  position: "relative",
                }}
                className="mapcomponent_subcontainer"
              >
                <MapComponent
                  className="map_container_three"
                  {...(tripStatus !== 3 && {
                    containerDetailMap: mapData,
                    companyName: companyName,
                  })}
                />
              </div>
            </div>
          </Col>

          {/* Right Column */}
          <Col
            xs={24}
            sm={24}
            md={8}
            lg={8}
            xl={8}
            className="container_map_subcomponent"
          >
            <Card bordered style={{ borderRadius: 12, width: "100%" }}>
              {/* Asset Info Section */}
              <div
                style={{
                  marginBottom: 16,
                  borderRadius: 12,
                  border: "1px solid #e6e6e6",
                  padding: 16,
                }}
              >
                <p className="asset-info">Asset Info</p>
                <p>
                  <span className="asset-content">Driver:</span>{" "}
                  <span className="asset-value">
                    {consign?.DriverName}
                  </span>
                </p>
                <p>
                  <span className="asset-content">Device ID:</span>{" "}
                  <span className="asset-value">
                    {assetInfoStatus?.FObject?.[0]?.FAssetID}
                  </span>
                </p>
                <p>
                  <span className="asset-content">Last Signal:</span>{" "}
                  <span className="asset-value">
                    {formatDateTimeEAT(assetInfoStatus?.FObject?.[0]?.FGPSTime)}
                  </span>
                </p>
                <p>
                  <span className="asset-content">Consignee:</span>{" "}
                  <span className="asset-value">{consignee}</span>
                  <span className="asset-value">{ }</span>
                </p>
                <p>
                  <span className="asset-content">Address:</span>{" "}
                  <span className="asset-value">{mapData?.locationName}</span>
                </p>
              </div>

              {/* Status Section */}
              <div
                style={{
                  marginBottom: 16,
                  borderRadius: 12,
                  border: "1px solid #e6e6e6",
                  padding: 16,
                }}
              >
                <p className="asset-info">Status</p>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 8,
                    alignItems: "center",
                  }}
                >
                  <span className="asset-content">Signal</span>
                  <span style={{ display: "flex", gap: 4 }}>
                    <Strong />
                    <Weak style={{ marginLeft: "15px" }} />
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 4,
                  }}
                >
                  <span className="asset-content">Lock Status</span>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#979797",
                      fontWeight: 400,
                      gap: 4,
                    }}
                  >
                    {assetInfoStatus?.FObject?.[0]?.FLockStatus === 0 ? (
                      <Lock />
                    ) : (
                      <RedUnlock />
                    )}
                    {assetInfoStatus?.FObject?.[0]?.FLockStatus === 0
                      ? "Locked"
                      : "Unlocked"}
                  </span>
                </div>
                <div
                  style={{ color: "#999", marginBottom: 8, textAlign: "right" }}
                >
                  Lock rope:{" "}
                  {assetInfoStatus?.FObject?.[0]?.FLockRope === 0
                    ? "Insert"
                    : "Pull out"}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <span className="asset-content">Speed</span>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#979797",
                      gap: 4,
                    }}
                  >
                    <Speed /> {assetInfoStatus?.FObject?.[0]?.FSpeed} Km
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span className="asset-content">Battery</span>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#979797",
                      gap: 4,
                    }}
                  >
                    <GreenBattery />
                    {assetInfoStatus?.FObject?.[0]?.FBattery}%
                  </span>
                </div>
              </div>

              {/* Operation Section */}
              <div
                style={{
                  borderRadius: 12,
                  border: "1px solid #e6e6e6",
                  padding: 16,
                }}
              >
                <p className="asset-info">Operation</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    marginTop: 8,
                  }}
                >
                  {tripStatus !== undefined &&
                    tripStatus !== null &&
                    tripStatus !== "" &&
                    tripStatus !== 3 && (
                      <div style={{ textAlign: "center" }}>
                        <div
                          style={{
                            backgroundColor: "#e6fff2",
                            borderRadius: "50%",
                            padding: 12,
                            marginBottom: 4,
                            display: "inline-block",
                            cursor: unlockAllowed ? "pointer" : "not-allowed",
                          }}
                          onClick={() => {
                            if (!unlockAllowed) return;
                            setIsUnlockModalVisible(true);
                          }}
                        >
                          <Tooltip
                            title={!unlockAllowed ? "No permission" : ""}
                          >
                            <BlackLock style={{ fontSize: 20 }} />
                          </Tooltip>
                        </div>
                        <div>Unlock</div>
                      </div>
                    )}
                  <div style={{ textAlign: "center" }}>
                    <div
                      style={{
                        backgroundColor: "#e6fff2",
                        borderRadius: "50%",
                        padding: 12,
                        marginBottom: 4,
                        display: "inline-block",
                        cursor: createAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        // setDrawyeropen(true); // Open the drawer
                        if (!updateAllowed) return;
                        setOpen(true); // Set edit mode
                      }}
                    >
                      <Tooltip title={!updateAllowed ? "No permission" : ""}>
                        <Edit style={{ fontSize: 20 }} />
                      </Tooltip>
                    </div>
                    <div>Edit</div>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <div
                      style={{
                        backgroundColor: "#ffe6e6",
                        borderRadius: "50%",
                        padding: 12,
                        marginBottom: 4,
                        display: "inline-block",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (!deleteAllowed) return;
                        setIsDeleteModalVisible(true);
                      }} // Open the modal on click
                    >
                      <Tooltip title={!deleteAllowed ? "No permission" : ""}>
                        <RedDelete
                          style={{
                            fontSize: 20,
                            color: "red",
                            cursor: createAllowed ? "pointer" : "not-allowed",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div>Delete</div>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
        <br />
        {/* Tabs Section */}
        <Row gutter={16}>
          <Col xs={24}>
            <Card>
              <Tab
                defaultActiveKey={activeTab}
                items={tabItems}
                onChange={handleTabChange}
              />
            </Card>
          </Col>
        </Row>
      </TitleStyle>
      <Modal
        title="Event Location"
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "10px",
            marginBottom: "16px",
          }}
        >
          <MapComponent locationsTL={[selectedRecord]} isminimap={true} />
          {/* Map Placeholder */}
        </div>
      </Modal>
      <UIModal
        width={500}
        open={isUnlockModalVisible}
        onClose={() => setIsUnlockModalVisible(false)} // Close the modal
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h6>
            You are about to remotely unlock the device{" "}
            <b>{assetInfoStatus?.FObject?.[0]?.FAssetID}</b>, continue?
          </h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={handleUnlock} // Call the unlock function
              loading={loading}
            >
              Confirm
            </ButtonFilled>
            <Buttontransparent
              onClick={() => setIsUnlockModalVisible(false)} // Close the modal
            >
              Cancel
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)} // Close the modal
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h6>Would you like to confirm the deletion of this trip?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={handleDelete} // Call the delete function
              loading={loading}
            >
              Confirm
            </ButtonFilled>
            <Buttontransparent
              onClick={() => setIsDeleteModalVisible(false)} // Close the modal
            >
              Cancel
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <ReusableDrawer
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            Modifying Consignments
          </div>
        }
        open={open}
        setOpen={setOpen}
        onOk={handleSubmitForm}
        onClose={handleClose}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled onClick={() => form.submit()} loading={loading}>
              Update
            </ButtonFilled>
          </div>,
        ]}
        children={
          <GridBuilder
            formStructureJson={combinedForm}
            handleSelectChange={handleSelectChange}
            handleChange={handleChange}
            formSubmit={handleSubmitForm}
            initialValues={formData}
            form={form}
          />
        }
      />
    </>
  );
};

export default TripDetails;
